import { render, staticRenderFns } from "./evaluationIndex.vue?vue&type=template&id=c5852a12&scoped=true"
import script from "./evaluationIndex.vue?vue&type=script&lang=js"
export * from "./evaluationIndex.vue?vue&type=script&lang=js"
import style0 from "./evaluationIndex.vue?vue&type=style&index=0&id=c5852a12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5852a12",
  null
  
)

export default component.exports